if (!customElements.get('gradation-details')) {
  class GradationDetails extends AccordionDetails {
    constructor() {
      super();
    }

    connectedCallback() {
      this.toggle(AfcTheme.config.mqlMobile ? false : true);
      document.addEventListener('matchMobile', () => {
        this.toggle(false);
      });
      document.addEventListener('unmatchMobile', () => {
        this.toggle(true);
      });
    }

    handleAfterToggle() {
      if (!AfcTheme.config.mqlMobile) {
        return;
      }

      if (this.isOpen) {
        const parent = this.closest('.accordion-parent') || document;
        const siblingsAccordions = parent.querySelectorAll('details[is="gradation-details"]');

        siblingsAccordions.forEach((details) => {
          if (details !== this) {
            details.open = false;
          }
        });
      }
    }
  }
  customElements.define('gradation-details', GradationDetails, { extends: 'details' });
}
